module.exports = __webpack_public_path__ + "5ddc10f117ae881d94ffdd129dec4f54.jpg";